/**
 * Copyright (c) 2021 MeetOnline.io
 *
 * long description for the file
 *
 * @summary Error Message Component
 * @author Rishabh <rishabh.it.007@gmail.com>
 *
 * Created at     : 2021-02-26 12:00:00
 * Last modified  : 2021-02-26 12:00:00
 */
import React from "react"
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  CloseButton
} from "@chakra-ui/react"
import { errorSelector } from "../../../recoil/atoms/error"
import { useRecoilState } from "recoil"
import { useBoolean } from "../../../hooks/useBoolean"

const ErrorMessage = () => {
  const [error, setError] = useRecoilState(errorSelector)
  const [value, { off }] = useBoolean()

  const closeError = (): void => {
    off()
    setError(null)
  }

  if (!value) return null

  if (!error) return null

  if (!error?.title) return null

  return (
    <Alert status="error" zIndex="100000">
      <AlertIcon />
      <AlertTitle mr={2}>{error.title}</AlertTitle>
      <AlertDescription>{error.message}</AlertDescription>
      <CloseButton
        position="absolute"
        right="8px"
        top="8px"
        onClick={closeError}
      />
    </Alert>
  )
}

export default ErrorMessage
